module.exports = __webpack_public_path__ + "static/media/story_4.d988d18b.png";